import { createApp } from 'vue';
import App from './app.vue';

const calendarApp = document.querySelector('#js-calendarApp');

if (calendarApp) {
  createApp(App).mount(calendarApp);
}

document.querySelectorAll('.js-mini-calendar-app').forEach((element) => {
  const configuration = JSON.parse(element.previousElementSibling.textContent);

  createApp(App, {
    configuration: {
      calendarOption: configuration.CalendarOptions,
      languageCode: configuration.LanguageCode,
      startPageId: configuration.StartPageId,
      miniCalendar: true,
      siteIdentifier: configuration.SiteIdentifier,
      numberOfItems: configuration.NumberOfItems,
      itemDisplayOption: configuration.ItemDisplayOption,
      categoryIds: configuration.CategoryIds,
      isStartPage: configuration.IsStartPage,
      showMoreLabel: configuration.ShowMoreLabel,
    },
  }).mount(element);
});
